import type { SharedContent } from 'src/models/cms/shared-content';
import { capitaliseFirstLetter } from 'src/helpers/string-helper';

export const clubBannerIsActive = (sharedData: SharedContent) =>
  sharedData.clubBanner && sharedData.clubBanner.showBanner;

export const getClubName = (hyphenatedClubName: string) => {
  return hyphenatedClubName.split('-').map(capitaliseFirstLetter).join(' ');
};
